/**
 * office ppt 数字编号对应的类型
 */
export const OfficeNumberType = {
    // 1. 2. 3.
    arabicPeriod: 'arabicPeriod',
    // 1) 2) 3)
    arabicParenR: 'arabicParenR',
    // (1) (2) (3)
    arabicParenBoth: 'arabicParenBoth',
    // A. B. C.
    alphaUcPeriod: 'alphaUcPeriod',
    // 一. 二. 三.
    ea1JpnChsDbPeriod: 'ea1JpnChsDbPeriod',
    // ① ② ③
    circleNumDbPlain: 'circleNumDbPlain',
    // I.II.III.
    romanUcPeriod: 'romanUcPeriod',
    // a. b. c.
    alphaLcPeriod: 'alphaLcPeriod',
    // 一. 二. 三.
    ea1ChsPeriod: 'ea1ChsPeriod',
    // ⅰ. ⅱ. ⅲ.
    romanLcPeriod: 'romanLcPeriod',
    // a) b) c)
    alphaLcParenR: 'alphaLcParenR',
};

export const NumberingCharacterTypes = Object.values(OfficeNumberType);

/**
 * 为了保证 slide 内置数字编号在 slide 中和导出后在 office 中展示一致，
 * 产品在【项目符号编辑面板】这个需求中重新整理了下 slide 内置编号
 * 最终在 office ppt 默认支持的一堆编号中选取了 7 个作为内置编号
 * https://docs.qq.com/sheet/DTFdVQ0tobHRnWVhQ?tab=BB08J2
 */
export const BuiltinNumberingTypes = [
    OfficeNumberType.arabicPeriod,
    OfficeNumberType.arabicParenBoth,
    OfficeNumberType.alphaUcPeriod,
    OfficeNumberType.circleNumDbPlain,
    OfficeNumberType.romanUcPeriod,
    OfficeNumberType.alphaLcPeriod,
    OfficeNumberType.ea1JpnChsDbPeriod,
];

// 内置项目符号的类型
export const CharacterTypes = {
    ITEMSYMBOL_NONE: 'itemSymbol_none',
    ITEMSYMBOL_CIRCLE: 'itemSymbol_circle',
    ITEMSYMBOL_SQUARE: 'itemSymbol_square',
    ITEMSYMBOL_RHOMBUS: 'itemSymbol_rhombus',
    ITEMSYMBOL_STAR: 'itemSymbol_star',
    ITEMSYMBOL_CHECK: 'itemSymbol_check',
    ITEMSYMBOL_ARROW: 'itemSymbol_arrow',
    ITEMSYMBOL_SMALL_CIRCLE: 'itemSymbol_small_circle',

    CUSTOM_TEXT: 'custom_text',
    CUSTOM_IMAGE: 'custom_image',
    ...OfficeNumberType,
};

// 内置的项目符号配置
// charset 字段 slide 没有使用，取的是 office 的值
export const BuiltInBulletCharacterConfigs = [
    {
        typeface: 'Wingdings',
        character_bullet_char: 'l',
        charset: 2,
        type: CharacterTypes.ITEMSYMBOL_CIRCLE,
    },
    {
        typeface: 'Wingdings',
        character_bullet_char: 'n',
        charset: 2,
        type: CharacterTypes.ITEMSYMBOL_SQUARE,
    },
    {
        typeface: 'Wingdings',
        character_bullet_char: 'u',
        charset: 2,
        type: CharacterTypes.ITEMSYMBOL_RHOMBUS,
    },
    {
        typeface: 'Zapf Dingbats',
        character_bullet_char: '✧',
        charset: 2,
        type: CharacterTypes.ITEMSYMBOL_STAR,
    },
    {
        typeface: 'Wingdings',
        character_bullet_char: 'ü',
        charset: 2,
        type: CharacterTypes.ITEMSYMBOL_CHECK,
    },
    {
        typeface: 'Wingdings',
        character_bullet_char: 'Ø',
        charset: 2,
        type: CharacterTypes.ITEMSYMBOL_ARROW,
    },
    {
        typeface: 'Arial',
        character_bullet_char: '•',
        charset: 0,
        type: CharacterTypes.ITEMSYMBOL_SMALL_CIRCLE,
    },
];
